import classNames from "classnames";
import React from "react";
import styles from "./icons.css";

interface Props {
  onClick(): void;
}
export const ElementFormDeleteIcon = ({ onClick }: Props) => {
  return (
    <i
      className={classNames(styles.icon, styles["delete-hover"], "icon-trash-dashboard")}
      onClick={onClick}
    />
  );
};
